import styled from 'styled-components';

export const ExistingCustomerStyles = styled.div`
  position: relative;
  text-align: center;
  margin: auto;
  margin-top: 60px;
  width: 100%;
  max-width: 312px;
  font-family: Poppins;

  ${props => props.theme.media.sm} {  
    max-width: 830px;
    margin-top: 120px;
  }
  
  .title-container {
    margin: auto;
    margin-bottom: 50px;

    h3 {
      font-size: 30px;
      line-height: 36px;
      color: #5F5F5F; 
      font-weight: 500;
    }

    span {
      display: block;
      color: #707070;
      font-size: 22px;
      line-height: 33px;
      font-weight: 300;
    }
    
    ${props => props.theme.media.sm} {  
      margin-bottom: 80px;
      h3 {
        font-size: 40px;
        line-height: 60px;
        margin: auto;
      }

      span {
        font-size: 26px;
        line-height: 39px;
      }
    }
  }

  .actions {
    margin: auto;
    display: block;

    .action {
      margin-bottom: 49px;

      span {
        display: block;
        color: #707070;
        font-size: 26px;
        line-height: 32px;
        margin-bottom: 16px;
        font-weight: 600;
        font-style: italic;
      }

      .btn {
        background: #fff;
        color: #f15f22;
        border: 3px solid #f15f22;
        font-weight: 500;
      }
    }

    ${props => props.theme.media.sm} {  
      display: flex;
      gap: 108px;
      .action {
        span {
          font-size: 28px;
          line-height: 36px;
          width: 300px;
          margin: auto;
          margin-bottom: 20px;
        }

        .btn {
          width: 360px;
        }
      }
    }
  }
  
  .loading-message {
    position: absolute;
    top: 30px;
    left: 50%;
    width: 100%;
    max-width: 340px;
    display: block;
    background: #fff;
    padding: 15px;
    transform: translateX(-50%);
    z-index: 999;
    box-shadow: 0 0 15px rgb(0 0 0 / 10%);

    ${props => props.theme.media.md} {
      margin-top: 12%;
    }
  }
`;
